/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import SectionData from 'components/machine/sectionData';
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { SectionRowElementTable } from 'templates/pubSub/types/TemplateType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import { usePubSubNode, usePubSubValue } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import SectionElementContentTableRowPlaceholder from './SectionElementContentTableRowPlaceholder';

interface ISectionElementContentTableProps {
  templateContext: TemplateContext;
  element: SectionRowElementTable;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementContentTable(props: ISectionElementContentTableProps): ReactElement {
  const filterLabel = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.element.labelVariable?.variablePath,
  );
  const nodeLabel = usePubSubNode(filterLabel, props.startingNodeId);
  const valueLabel = usePubSubValue(nodeLabel);

  const label = valueLabel !== undefined ? valueLabel : props.element.label;

  return (
    <SectionData cols="col-12 col-sm-12 col-md-12" label={label}>
      <table className="table table-bordered table-striped table-hover">
        <thead className="table-light">
          <tr>
            {props.element.columns.map((column, columnIndex) => (
              <th key={columnIndex}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.element.rowPlaceholders && (
            <SectionElementContentTableRowPlaceholder
              templateContext={props.templateContext}
              element={props.element}
              placeholder={props.element.rowPlaceholders[0]}
              placeholderIndex={0}
              startingNodeId={props.startingNodeId}
            />
          )}
        </tbody>
      </table>
    </SectionData>
  );
}
